import React from 'react';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import VideoLogo from './VideoLogo';
import TwilioLogo from './TwilioLogo';
import { useAppState } from '../../state';
import UserMenu from './UserMenu/UserMenu';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
  background: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#1D1D1D',
    minHeight: '100vh',
    padding: '20px',
  },
  container: {
    position: 'relative',
    width: '100%',
    maxWidth: '1000px',
    margin: 'auto',
  },
  innerContainer: {
    display: 'flex',
    borderRadius: '12px',
    overflow: 'hidden',
    position: 'relative',
    margin: 'auto',
    background: 'white',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      maxWidth: '400px',
    },
  },
  brandContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#0054ec',
    backgroundImage: 'linear-gradient(135deg, #0054ec 0%, #D84646 100%)',
    width: '40%',
    padding: '40px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '30px',
    },
  },
  logoContainer: {
    textAlign: 'center',
    color: 'white',
    '& svg': {
      width: '80px',
      height: '80px',
      marginBottom: '20px',
    },
  },
  content: {
    background: 'white',
    width: '60%',
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '30px',
    },
  },
  title: {
    color: 'white',
    fontWeight: 500,
    fontSize: '1.5rem',
    margin: '0',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
  },
  twilioLogo: {
    position: 'absolute',
    top: 0,
    left: 0,
    margin: '20px',
    '& svg': {
      width: '100px',
      height: 'auto',
    },
  },
  userMenu: {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: '20px',
  },
}));

interface IntroContainerProps {
  children: React.ReactNode;
}

const IntroContainer = (props: IntroContainerProps) => {
  const classes = useStyles();
  const { user } = useAppState();
  const location = useLocation();

  return (
    <div className={classes.background}>
      <div className={classes.container}>
        <TwilioLogo className={classes.twilioLogo} />
        {user && location.pathname !== '/login' && (
          <div className={classes.userMenu}>
            <UserMenu />
          </div>
        )}
        <div className={classes.innerContainer}>
          <div className={classes.brandContainer}>
            <div className={classes.logoContainer}>
              <VideoLogo />
              <Typography variant="h6" className={classes.title}>
                
              </Typography>
            </div>
          </div>
          <div className={classes.content}>{props.children}</div>
        </div>
      </div>
    </div>
  );
};

export default IntroContainer;